<script>
// Importing Line class from the vue-chartjs wrapper
import { Line } from 'vue-chartjs'

// Exporting this so it can be used in other components
export default {
  extends: Line,
  props: {
    laborByHour: null,
    comparison: null,
    hours: null,
    historic: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      datacollection: {
        // Data to be represented on x-axis
        labels: [],
        datasets: []
      },
      // Chart.js options that controls the appearance of the chart
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: true,
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || ''

              if (label) {
                label += ': '
              }
              label += tooltipItem.yLabel + '%'
              return label
            }
          }
        }
      }
    }
  },
  mounted () {
    this.init()
  },
  watch: {
    comparison: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getDataSets()
        this.renderChart(this.datacollection, this.options)
      }
    },
    historic: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getDataSets()
        this.renderChart(this.datacollection, this.options)
      }
    }
  },
  methods: {
    init: function () {
      this.setHeaders()
      this.getDataSets()
      // renderChart function renders the chart with the datacollection and options object.
      this.renderChart(this.datacollection, this.options)
    },
    setHeaders: function () {
      for (var i = 0; i < this.hours.labels.length; i++) {
        this.datacollection.labels.push(this.hours.labels[i])
      }
    },
    getDataSets: function () {
      // clear chart datasets
      this.datacollection.datasets = []
      this.createDataSet(this.laborByHour.summary, 'Current', 'red')
      // historic data can take a while to load, so don't try until we have something.
      if (typeof this.historic[this.comparison] !== 'undefined') {
        this.createDataSet(this.historic[this.comparison].summary, this.historic[this.comparison].label, this.historic[this.comparison].color)
      }
    },
    createDataSet (summary, label, color) {
      const data = {
        label: label,
        backgroundColor: color,
        borderColor: color,
        fill: false,
        pointBackgroundColor: color,
        borderWidth: 1,
        // pointBorderColor: '#249EBF',
        // Data to be represented on y-axis
        data: this.getDataArray(summary)
      }
      this.datacollection.datasets.push(data)
    },
    getDataArray (summary) {
      const data = []
      for (var i = 0; i < this.hours.values.length; i++) {
        let hasdt = false
        summary.forEach(d => {
          // match the data point to the correct hour
          // let's up keep the chart in the format of their open time
          if (d.hour === this.hours.values[i]) {
            data.push(+d.percent)
            hasdt = true
          }
        })
        if (hasdt === false) {
          data.push('')
        }
      }
      return data
    }
  }
}
</script>
